import { Header } from '@/components/header'
import { Footer } from '@/components/footer'
import { CheckResultsSection } from '@/components/check-results-section'
import { CentralGovernmentLinksSection } from '@/components/central-government-links-section'

export default function StudentSection() {

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="mb-8">
          <div className="text-center">
            <h1 className="font-poppins text-3xl md:text-4xl font-bold text-foreground mb-2">
              Info
            </h1>
            <p className="font-inter text-muted-foreground text-lg">
              Access important links for results, jobs, and other government services
            </p>
          </div>
        </div>

        <CheckResultsSection />
        
        <div className="mt-12">
          <CentralGovernmentLinksSection />
        </div>
      </main>
      <Footer />
    </div>
  )
}

